// extracted by mini-css-extract-plugin
module.exports = {"chileanFire":"#d52"};